import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6832 4.91115C15.4266 4.65453 15.0118 4.65453 14.7552 4.91115L13.2502 6.41607L9.5841 2.74992L11.089 1.245C11.3456 0.988381 11.3456 0.573592 11.089 0.316975C10.8324 0.0603573 10.4176 0.0603573 10.161 0.316975L8.29379 2.18418L4.44584 3.60772C3.46925 3.96934 2.71515 4.78317 2.429 5.7847L0.196884 13.6086C0.0144299 14.2295 0.185071 14.8995 0.643176 15.357C0.979863 15.6943 1.43206 15.8755 1.89279 15.8755C2.05753 15.8755 2.22357 15.8525 2.38568 15.8046L10.1853 13.5882C11.1835 13.3047 11.9967 12.5552 12.3609 11.5839L13.8147 7.70703L15.6825 5.83917C15.9392 5.58256 15.9392 5.16777 15.6825 4.91115H15.6832ZM11.1317 11.1231C10.9131 11.7059 10.4255 12.1555 9.82627 12.3261L2.5281 14.4001L6.34652 10.5817C6.45481 10.6106 6.569 10.6263 6.68648 10.6263C7.41171 10.6263 7.99911 10.0389 7.99911 9.31368C7.99911 8.58846 7.41171 8.00106 6.68648 8.00106C5.96126 8.00106 5.37386 8.58846 5.37386 9.31368C5.37386 9.43116 5.38962 9.54536 5.41849 9.65365L1.60073 13.4714L3.69043 6.14633C3.86238 5.54515 4.31458 5.05685 4.90066 4.83961L8.48871 3.5119L12.4863 7.50948L11.1317 11.1231Z"
      className="iconBorder"
    />
  </svg>
);

const PenIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default PenIcon;
